var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"xl":"6","cols":"12"}},[_c('address-nav')],1),_c('b-col',{staticClass:"m-t-10 m-xl-t-0",attrs:{"xl":"6","cols":"12"}},[_c('afip-ticket-nav')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }